import { createContext, useContext, useState, useEffect } from "react";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

const KEY = "sv_wishlist";

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(ids)); }, [ids]);

  const toggle = (productId) =>
    setIds((prev) => (prev.includes(productId) ? prev.filter((x) => x !== productId) : [...prev, productId]));

  const has = (productId) => ids.includes(productId);

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}
